import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import Rest from '../../webapi/Rest';
import { isNullOrUndefined } from 'util';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter } from 'arm-common';
import FormatMoney from '../shared/formatMoney.js';


class GaraziePremio extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            docCategory: null,
            showConfirm: false,
            showConfirmDelete: false,
            idDocumentDelete: null
        }
        this.componentName = "[GaraziePremio.jsx] ";
    }

    componentDidMount() {
        console.log(this.componentName + "componentDidMount");

        let columns = [
            { field: 'nomeGaranzia', title: i18n('ARM.CORE.PRODUCT.GARANZIA', 'Garanzia'), sortable: 'true' },
            { field: 'premioLordo', formatter: this.formatMoney, title: i18n('ARM.CORE.PRODUCT.PREMIO.IMPORTO_LORDO', 'Importo Lordo'), sortable: 'true' },
        ];


        $(this.refs.ListGaranzieTable).bootstrapTable({
            columns: columns,
            idField: "nomeGaranzia",
            // sortable: true,
            // search: true,
            // showColumns: true,
            //showExport: true,
            // exportDataType: 'all',
            //showToggle: "true",
            detailView: "true",
            detailFormatter: (row, $element, field) => this.detailFormatter(row, $element, field),
            //exportTypes: ['json', 'xml', 'csv', 'txt', 'sql', 'excel'],
            maintainSelected: "true",
            sortName: 'nomeGaranzia',
            sortOrder: "desc",
            // pagination: true,
        });

        if (!isNullOrUndefined(this.props.premio) && !isNullOrUndefined(this.props.premio.listaPremiPojo)) {
            console.log("\t rows: " + (this.props.premio.listaPremiPojo !== null ? this.props.premio.listaPremiPojo.length : "NULL"));
            $(this.refs.ListGaranzieTable).bootstrapTable('load', this.props.premio.listaPremiPojo);
        }


    }

    formatMoney(value, row, index) {
        return FormatMoney.formatMoney(row.premioLordo, 2, ",", ".")
    }

    detailFormatter(rowIndex, element, field) {
        //cerco nei premi quello della garanzia [nomeGaranzia] ricevuto in ingresso e ritorno il dettaglio
        let garanzia = null;
        let indexGaranziaElement = this.props.premio.listaPremiPojo.map(function (premio) { return premio.nomeGaranzia; }).indexOf(element.nomeGaranzia);
        if (indexGaranziaElement !== null && indexGaranziaElement !== -1) {
            garanzia = this.props.premio.listaPremiPojo[indexGaranziaElement];
        }
        if (!isNullOrUndefined(garanzia)) {
            //per inserire lo style style='color: #92BF3C; font-size:x-large'
            return "<p> <i  class=' font-weight-bold col-4'> " + i18n('ARM_CORE_PRODUCT.LORDO', 'Lordo') +"</i>" + FormatMoney.formatMoney(garanzia.premioNetto, 2, ",", ".") + "</p>" + "<p> <i class=' font-weight-bold  col-4'> " + i18n('ARM_CORE_PRODUCT.ACCESSORI', 'Accessori') +"</i>" + FormatMoney.formatMoney(garanzia.accessoriDiv, 2, ",", ".") + "</p>" + "<p> <i class=' font-weight-bold  col-4'>" + i18n('ARM_CORE_PRODUCT.IMPOSTE', 'Imposte') + " </i>" + FormatMoney.formatMoney(garanzia.imposteDiv, 2, ",", ".") + "</p>";
        }
        return "";
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.premio && nextProps.premio.listaPremiPojo && (!this.props.premio || !this.props.premio.listaPremiPojo || nextProps.premio.listaPremiPojo !== this.props.premio.listaPremiPojo)) {
            console.log("\t rows: " + (nextProps.premio.listaPremiPojo !== null ? nextProps.premio.listaPremiPojo.length : "NULL"));
            $(this.refs.ListGaranzieTable).bootstrapTable('load', nextProps.premio.listaPremiPojo);
        }
    }

    render() {
        console.log(this.componentName + 'render');
        let premio = this.props.premio

        let prodotto = this.props.prodotto;
        return (
            <div key={"sezioneDocumentiGaranzie"} style={{ paddingTop: '25px', }} className="row col-12 pt-2 bg-white m-0 p-0 border-0 d-flex justify-content-around">
                {
                    (isNullOrUndefined(premio) || isNullOrUndefined(premio.errorMsgPremio) || premio.errorMsgPremio === "") ?
                        <div id="garanzieProduct" className=" col-12   p-0 ">
                            <div className="" style={{ alignItems: 'center' }}>
                                <div className="d-flex justify-content-around" id="headingOne">
                                    <a key={"dettaglioGaranzie"} data-toggle="collapse" data-target="#garanzie" aria-expanded="true" aria-controls="garanzie" type="button " onClick={this.props.onClick} style={{ minWidth: '215px' }} className="btn mb-3 mt-1"> <i className="fas fa-list"></i>{i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLIO_GARANZIE', ' Dettaglio Garanzie')} </a>
                                </div>

                                <div id="garanzie" className="collapse" aria-labelledby="headingOne" data-parent="#garanzieProduct">
                                    <div className="card-body p-0">
                                        <div className=" justify-content-around">
                                            <div className="col-12 pl-1">
                                                <div className="table-responsive">
                                                    <table ref="ListGaranzieTable" className="table table-striped table-hover ListGaranzieTable" />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null
                }


            </div >

        );
    }
};

function mapStateToProps(state) {
    return {
    }
};

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GaraziePremio);

